import * as React from "react";
import { withFeatureFlags, Plugin, compose } from "@atlassiansox/microscopekit";
import { LinterPage } from "./service/pages/linter-page";
import { LinterNavigation } from "./service/navigation/linter-service-links";
// Microscope imports your plugin from here
export class LinterPluginComponent extends React.Component {
    render() {
        const { flags } = this.props;
        if (!flags["linterPluginEnabled"]) {
            return React.createElement(Plugin, { id: "linter" });
        }
        return (React.createElement(Plugin, { id: "linter", serviceContainer: {
                routes: [
                    {
                        path: "linter",
                        component: LinterPage
                    }
                ],
                navigation: [
                    {
                        id: "service-navs",
                        component: LinterNavigation
                    }
                ]
            } }));
    }
}
const LinterPlugin = compose(withFeatureFlags)(LinterPluginComponent);
export default LinterPlugin;
